import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesReportsVideoMain } from './modules/ui/Main';

const ReportsVideoPage = (
  <SuspensePage>
    <PagesReportsVideoMain />
  </SuspensePage>
);

export default ReportsVideoPage;
